"use client"

import type { PromotionBottomBannerProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { generateResponsiveCSS } from "../../../lib/helper"
import { PromotionBottomBannerContent } from "./components/PromotionBottomBannerContent"
import { usePromotionBottomBanner } from "./hooks/usePromotionBottomBanner"

export const RenderConfig: ComponentConfig<PromotionBottomBannerProps> = {
  render: ({
    banners,
    mobileHeight,
    desktopHeight,
    className,
    styles,
    responsiveType,
    id: componentId,
  }: PromotionBottomBannerProps & { id?: string }) => {
    const { id } = usePromotionBottomBanner({
      banners,
      componentId,
    })

    const mergedStyles = styles || {}
    const responsiveCSS = generateResponsiveCSS(id, mergedStyles, responsiveType || "mobileFirst")

    return (
      <>
        {responsiveCSS}
        <PromotionBottomBannerContent
          id={id}
          banners={banners}
          mobileHeight={mobileHeight}
          desktopHeight={desktopHeight}
          className={twMerge(className)}
        />
      </>
    )
  },
}
